import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";
import queryString from "query-string";

export const getDenominations = ({ filter }) => {
  return axios.get(`/denominations?${queryString.stringify(filter)}`);
};

export const useDenominations = ({ config, filter } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["denominations", JSON.stringify(filter)],
    queryFn: () => getDenominations({ filter })
  });
};
